export default __webpack_public_path__ + "static/media/getmore.9bd3cd74.jpg";